//@ts-nocheck
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import InputForm, { AutoCompleteValue } from "../../../Components/InputForm/InputForm";
import ButtonForm from "../../../Components/ButtonForm/ButtonForm";
import { APICall } from "../../../Helpers/Network/APICalls";
import { getCompanyDataById, insertUpdateCompanyData } from "../../../Helpers/APIEndPoints/EndPoints";
import { useLocation } from "react-router-dom";
import { LoaderContext, getContext } from "../../../Helpers/Context/Context";
import notify, { ToastType } from "../../../Helpers/ToastNotification";
import "./CompanyMaster.css";
import { ApiStatus } from "../../../Helpers/Enums/ApiStatus";
import { useSelector } from "react-redux";

const CompanyMasterEdit = () => {
  const { state } = useLocation();
  let navigate = useNavigate();
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [company, setCompany] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [editMode, setEditMode] = useState(false);
  // submit validation
  const [formErrors, setFormErrors] = useState({});
  const [code, setCode] = useState("");
  const context = useSelector((state: any) => state.updateReduxStore);
  let formErrorObj = {};

  const onSubmitValidation = () => {
    setFormErrors({});
    formErrorObj = {};
    if (!company || company === "") {
      formErrorObj["Company_isEmpty"] = "Company can not be empty";
    }
    if (company.length > 200) {
      formErrorObj["Company_isEmpty"] = "Company name must be less than 200 characters";
    }
    if (!code || code === "") {
      formErrorObj["Code_isEmpty"] = "Code can not be empty";
    }
    setFormErrors(formErrorObj);
  };

  useEffect(() => {
    (async () => {
      showLoader();
      setEditMode(true);
      if (state !== null && state.id && state.id > 0) {
        await getCompanyDataByIdF();
      }
      hideLoader();
    })();
  }, []);

  const getCompanyDataByIdF = async () => {
    let obj = {
      Id: state.id,
    };
    const resp = await APICall(getCompanyDataById, obj);
    if (resp?.Data?.Data?.length > 0) {
      setEditMode(false);
      setCompany(resp.Data.Data[0].Name);
      setCode(resp.Data.Data[0].Code);
      setIsActive(resp.Data.Data[0].IsActive);
    }
  };

  const onClickFunction = async (action: any) => {
    showLoader();
    if (action === "Submit") {
      await onSubmitValidation();
      let isEmpty = Object.values(formErrorObj).every((f) => {
        return f === "" || f === null || f === undefined;
      });
      if (isEmpty === true) {
        let param = {
          Id: state.id != null || state.id != 0 ? state.id : 0,
          Name: company,
          Code: code,
          IsActive: isActive,
          CreatedBy: context.Id,
        };
      

        const insertData = await APICall(insertUpdateCompanyData, param);

       
        // if (insertData?.Data?.Status == ApiStatus.Error) {
        //   notify(1, insertData?.Data?.Data);
        // } else if (insertData?.Status == ApiStatus.Error) {
        //   notify(1, insertData?.Data);
        // } else if (insertData?.Data != null) {
        
        if (insertData?.Data?.Status == ApiStatus.Error) {
          const errors = insertData?.Data?.Data;
          const errorComponent = Array.isArray(errors) ? <div dangerouslySetInnerHTML={{ __html: errors?.join("<br />") }} /> : errors;
          notify(1, errorComponent);
        } else if (insertData?.Status == ApiStatus.Error) {
          notify(1, insertData?.Data);
        } else if (insertData?.Data != null) {
          if (state !== null && state.id && state.id > 0) {
            notify(0, "Company successfully updated");
          } else {
            notify(0, "Company successfully inserted");
          }
          navigate(-1);
        }
      }
    } else if (action === "Reset") {
      resetFunction();
    } else if (action === "Cancel") {
      navigate(-1);
    }
    hideLoader();
  };

  const handleKeyNumbers = (event) => {
    // Prevent numeric character input
    const charCode = event.which || event.keyCode; // Handle cross-browser compatibility
    if (charCode >= 48 && charCode <= 57) {
      event.preventDefault();
    }
  };

  const handleTextEvent = async (event: any, field: any) => {
    let value = event.target.value;
    const regex = /^[0-9]+$/;
    if (field === "company") {
      setCompany(value);
    }
    if (field === "code") {
      if (value === "" || regex.test(value)) {
        if (value.length > 10) {
          value = value.slice(0, 10);
        }
        setCode(value);
      }
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "-" || event.key === "e" || event.key === "E") {
      event.preventDefault();
    }
  };

  const resetFunction = () => {
    setFormErrors({});
    formErrorObj = {};
    setCompany("");
    setCode("");
  };

  return (
    <>
      <div>
        <div className="">
          <div className="col-lg-12 col-md-12 p-0">
            <div className="row">
              <div className="col-lg-3 col-sm-3 col-xs-3 ">
                <div className="form-group"></div>
                <label>Company</label>
                <sup style={{ fontSize: "13px" }}>*</sup>
                <InputForm
                  // disabled={editMode ? true : false}
                  placeholder={""}
                  value={company}
                  onChange={(e) => handleTextEvent(e, "company")}
                  textArea={false}
                  onKeyPress={handleKeyNumbers}
                />
                <p style={{ color: "red" }}>{formErrors["Company_isEmpty"]}</p>
              </div>
              <div className="col-lg-3 col-sm-3 col-xs-3 ">
                <div className="form-group"></div>
                <label>Code</label>
                <sup style={{ fontSize: "13px" }}>*</sup>
                <InputForm
                  // disabled={editMode ? true : false}
                  placeholder={""}
                  value={code}
                  onChange={(e) => handleTextEvent(e, "code")}
                  onKeyPress={(e) => handleKeyPress(e)}
                  textArea={false}
                />
                <p style={{ color: "red" }}>{formErrors["Code_isEmpty"]}</p>
              </div>
              <div className="col-lg-3 col-sm-3 col-xs-3 ">
              <div className="form-group"></div>
                <div className="form-group">
                  <label className="col-form-label">Active Status</label>
                  <sup>*</sup>
                  <div className="custom-checkbox">
                    <input
                      autoComplete={AutoCompleteValue}
                      disabled={editMode ? true : false}
                      type="checkbox"
                      onChange={(e) => setIsActive(e.target.checked)}
                      name="isActive"
                      checked={isActive}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end mt-3">
          <div>
            <ButtonForm className="btn btn-submit" style={{ marginLeft: 5 }} id="submit" value={<p><i className="fas fa-paper-plane" /> Submit</p>} onClick={() => onClickFunction("Submit")} />
          </div>
          {state !== null && state.id && state.id > 0 ? (
            ""
          ) : (
            <div>
              <ButtonForm className="btn btn-info" id="Reset" icon={"fas fa-undo"} style={{ marginLeft: 5 }} value={<p><i className="fas fa-undo" /> Reset</p>}  onClick={() => onClickFunction("Reset")} />
            </div>
          )}
          <div>
            <ButtonForm className="btn btn-cancel" id="cancel"  style={{ marginLeft: 5 }} value={<p><i className="far fa-times-circle" /> Cancel</p>} onClick={() => navigate("/master/CompanyMaster")} />
          </div>
        </div>
      </div>
    </>
  );
};

export default CompanyMasterEdit;
